import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMobileHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.1398 1.27115L1.63981 7.22115C1.23882 7.50184 1 7.96053 1 8.45V19.169C1 19.9974 1.67157 20.669 2.5 20.669H6.07895C6.86377 20.669 7.5 20.0328 7.5 19.248V15.169C7.5 13.236 9.067 11.669 11 11.669C12.933 11.669 14.5 13.236 14.5 15.169V19.248C14.5 20.0328 15.1362 20.669 15.9211 20.669H19.5C20.3284 20.669 21 19.9974 21 19.169V8.45C21 7.96053 20.7612 7.50184 20.3602 7.22115L11.8602 1.27115C11.3437 0.909616 10.6563 0.909616 10.1398 1.27115Z",
		stroke: "#5583F6",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMobileHome;
